"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightNumberEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Field_1 = require("../../../Form/Field");
const FlightNumberEditor = (props) => {
    const { field, prefix } = props;
    const fieldProps = {
        name: 'number',
        modificators: field.modifiers,
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:Number', defaultMessage: 'Flight number' })),
        prefix: prefix !== null && prefix !== void 0 ? prefix : 'XX',
        error: field.error,
        value: field.input,
        onChange: field.onEvent,
    };
    return (react_1.default.createElement(Field_1.FormField, { ...fieldProps }));
};
exports.FlightNumberEditor = FlightNumberEditor;
//# sourceMappingURL=FlightNumberEditor.js.map